import { assets } from '@cmg/common';
import { Box, Stack, Typography } from '@cmg/design-system';
import React from 'react';

export const MappingHeader: React.FC = () => (
  <Stack direction="row" gap={3} mt={-2.5}>
    <Box flex={1} display="flex" alignItems="center">
      <Typography variant="body1" color="text.secondary">
        CRM:
      </Typography>
    </Box>

    <Box flex={1} display="flex" alignItems="center" gap={0.5}>
      <Box component="img" src={assets.logoNoText} width={14} height={14} />
      <Typography variant="body1" color="text.secondary">
        CMG:
      </Typography>
    </Box>
  </Stack>
);
